import {Injectable, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  permissionName: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  permissions_state?: string;
  target?: boolean;
  permissionName: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  nodeName: string;
  permissions: MainMenuItems[];
}

// const MENUITEMS = [
//   {
//     label: 'Dashboard',
//     main: [
//       {
//         state: 'dashboard',
//         name: 'Dashboard',
//         type: 'link',
//         icon: 'ti-home'
//       }
//         ]
//       },
//       {
//         label : 'Adminstration',
//         main: [
//           {
//             state: 'manageroles',
//             name: 'Manage Roles',
//             type: 'link',
//             icon: 'ti-layout-list-thumb'
//           },
//           {
//             state: 'manageusers',
//             name: 'Manage Users',
//             type: 'link',
//             icon: 'ti-id-badge'
//           },
//           {
//             state: 'customerdetails',
//             name: 'Manage Customers',
//             type: 'link',
//             icon: 'ti-user',
//             // children: [
//             //   {
//             //     state: 'customereditdetails',
//             //     name: 'CustomerEditDetails'
//             //   },
//             // ]
//           },
//         ]
//       },

//       // {
//       //   label: 'Manage Customers',
//       //   main: [
//       //     {
//       //       state: 'customerdetails',
//       //       name: 'Customer Details',
//       //       type: 'link',
//       //       icon: 'ti-user',
//       //     },
//       //   ]
//       // },
//        {
//         label: 'Content Pages',
//         main: [
//           {
//             state: 'contentpage',
//             name: 'Content Page',
//             type: 'link',
//             icon: 'ti-pencil-alt',
//           },
//         ]
//       },
// ];

@Injectable()
export class MenuItems {

//  private _baseurl = environment.baseURL + 'Permissions/GetAllPermissions';
//  private url = 'assets/data/menuitems.json';

  constructor(private http: HttpClient) {}

  // getAll(): any {
  //   this.http.get(this.url)
  //   .subscribe( data => {
  //       this.data = data;
  //       console.log(data);
  //   });

  getAll(): Observable<Menu[]> {
   const employeeDetails = JSON.parse(localStorage.getItem('employeeDetails'));
  // console.log(employeeDetails);
  // const roleId = employeeDetails.roleId;
    return this.http.get<Menu[]>('assets/data/menuitems.json');
    // return this.http.get(this.url)
    //   .map(data => {
    //     console.log(data);
    //    MENUITEMS = data;
    //    // return this.data;
    //   });
    // return MENUITEMS;
     }
  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}
